// 지금 플레이할 수 있는 지역 수(지도가 있는 지역, C2부터 6). 지도 계산이 없는 가벼운 모듈이다:
// 서버(Worker)가 rebirth.ts를 통해 content/stages.ts → stageMaps.ts를 끌어와 시작 CPU를 먹지 않도록 분리했다(Cloudflare 10021).
import { REGION_IDS } from '../levels';

export const PLAYABLE_REGIONS = REGION_IDS.length;
